"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _connectPromise = require("crm_data/flux/connectPromise");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _PipelineStageChangePrompt = _interopRequireDefault(require("customer-data-properties/prompt/PipelineStageChangePrompt"));

var _DealsStore = _interopRequireDefault(require("crm_data/deals/DealsStore"));

var _DealPipelineStore = _interopRequireDefault(require("crm_data/deals/DealPipelineStore"));

var _DealStageStore = _interopRequireDefault(require("crm_data/deals/DealStageStore"));

var _DealStagePropertiesStore = _interopRequireDefault(require("crm_data/deals/DealStagePropertiesStore"));

var _TicketsStore = _interopRequireDefault(require("crm_data/tickets/TicketsStore"));

var _TicketsPipelinesStore = _interopRequireDefault(require("crm_data/tickets/TicketsPipelinesStore"));

var _TicketsPipelinesStagesStore = _interopRequireDefault(require("crm_data/tickets/TicketsPipelinesStagesStore"));

var _TicketStagePropertiesStore = _interopRequireDefault(require("crm_data/tickets/TicketStagePropertiesStore"));

var _TicketStageStatusOptions = require("customer-data-objects/ticket/TicketStageStatusOptions");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _immutable = require("immutable");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _LoadingStatus = require("crm_data/flux/LoadingStatus");

var _ObjectsActions = _interopRequireDefault(require("crm_data/objects/ObjectsActions"));

var _get = _interopRequireDefault(require("transmute/get"));

var _registerService = _interopRequireDefault(require("crm_data/flux/registerService"));

var _loggers = require("customer-data-tracking/loggers");

var _PropertiesStore = _interopRequireDefault(require("crm_data/properties/PropertiesStore"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var DealsActions = _interopRequireWildcard(require("crm_data/deals/DealsActions"));

var TicketsActions = _interopRequireWildcard(require("crm_data/tickets/TicketsActions"));

var _DealPermissions = require("crm_data/BET/permissions/DealPermissions");

var _SettingsStore = _interopRequireDefault(require("crm_data/settings/SettingsStore"));

var _bustStoreCacheIfExpired = _interopRequireDefault(require("crm_data/flux/bustStoreCacheIfExpired"));

var _PropertyInput = _interopRequireDefault(require("customer-data-properties/input/PropertyInput"));

var _UserScopes = require("crm_data/scopes/UserScopes");

var _I18n = _interopRequireDefault(require("I18n"));

var _PropertyUpdateErrorHandler = _interopRequireDefault(require("customer-data-properties/PropertyUpdateErrorHandler"));

var _PropertyInputResolvers = require("customer-data-properties/resolvers/PropertyInputResolvers");

var _BLACKLISTED_PROPERTI;

var BLACKLISTED_PROPERTIES = (_BLACKLISTED_PROPERTI = {}, (0, _defineProperty2.default)(_BLACKLISTED_PROPERTI, _ObjectTypes.DEAL, ['pipeline', 'dealstage']), (0, _defineProperty2.default)(_BLACKLISTED_PROPERTI, _ObjectTypes.TICKET, ['hs_pipeline', 'hs_pipeline_stage']), _BLACKLISTED_PROPERTI);

var rethrowError = function rethrowError(err) {
  if (err instanceof Error) {
    throw err;
  }

  return err;
};

var trackClosedDeal = function trackClosedDeal(isDealWon, deal) {
  var amount = (0, _ImmutableModel.getProperty)(deal, 'amount'); //# ********** PUBLIC EVENT **********
  //# Public Events help teams across HubSpot automate work and customize experiences based on user actions.
  //# Speak with #product-insight and your PM before any shipping any changes to this event

  _loggers.CrmLogger.log('recordUsage', {
    action: "close deal " + (isDealWon ? 'won' : 'lost'),
    what_value: parseInt(amount, 10),
    type: _ObjectTypes.DEAL
  }); //# ********** PUBLIC EVENT **********

};

var trackTicketStageChange = function trackTicketStageChange(state, label) {
  _loggers.CrmLogger.logRecordInteraction(_ObjectTypes.TICKET, {
    action: 'Changed ticket status',
    type: state,
    label: label,
    count: 1
  });

  if (state === _TicketStageStatusOptions.CLOSED) {
    _loggers.CrmLogger.log('ticketsActivation');
  }
};

var getModalSavedCallback = function getModalSavedCallback(objectType, subject, nextProperties, nextStage) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return function (modalUpdates) {
    var propertyUpdates = nextProperties.merge((0, _immutable.Map)(modalUpdates));

    _ObjectsActions.default.updateStores(subject, nextProperties.merge((0, _immutable.Map)(modalUpdates)), {
      updatedValues: true,
      onError: function onError(err) {
        (0, _PropertyUpdateErrorHandler.default)(err);
        var objectActions = objectType === _ObjectTypes.DEAL ? DealsActions : TicketsActions;
        var objectIdKey = objectType === _ObjectTypes.DEAL ? 'dealId' : 'objectId';
        objectActions.revertMove(subject.get(objectIdKey));
      },
      onSuccess: options.onSuccess
    });

    if (objectType === _ObjectTypes.DEAL && [0, 1].includes(nextStage.get('probability'))) {
      var isDealWon = nextStage.get('probability') === 1;
      return trackClosedDeal(isDealWon, propertyUpdates.reduce(function (record, value, key) {
        return (0, _ImmutableModel.setProperty)(record, key, value);
      }, subject));
    }

    if (objectType === _ObjectTypes.TICKET) {
      trackTicketStageChange(nextStage.getIn(['metadata', 'ticketState']), nextStage.get('label'));
    }

    return null;
  };
};

var getModalCanceledCallback = function getModalCanceledCallback(subject, id, prevProperties, revertMove) {
  return function () {
    _ObjectsActions.default.updateStores(subject, prevProperties, {
      updatedValues: true,
      onError: _PropertyUpdateErrorHandler.default
    });

    return revertMove(id);
  };
};

var fetchDealInfo = (0, _connectPromise.connectPromise)({
  subject: {
    stores: [_DealsStore.default],
    deref: function deref(_ref) {
      var id = _ref.id;
      return _DealsStore.default.get(id);
    }
  },
  stages: {
    stores: [_DealsStore.default, _DealStageStore.default],
    deref: function deref(_ref2) {
      var prevProperties = _ref2.prevProperties,
          nextProperties = _ref2.nextProperties;

      var stages = _DealStageStore.default.get();

      if ((0, _LoadingStatus.isLoading)(stages)) {
        return undefined;
      }

      return {
        prev: (0, _get.default)((0, _get.default)('dealstage', prevProperties), stages),
        next: (0, _get.default)((0, _get.default)('dealstage', nextProperties), stages)
      };
    }
  },
  stageProperties: {
    stores: [_DealPipelineStore.default, _DealStageStore.default, _DealStagePropertiesStore.default, _PropertiesStore.default],
    deref: function deref(_ref3) {
      var nextProperties = _ref3.nextProperties;

      var requestedPropertiesByStage = _DealStagePropertiesStore.default.get();

      var allStageProperties = _PropertiesStore.default.get(_ObjectTypes.DEAL);

      var stages = _DealStageStore.default.get();

      var pipelines = _DealPipelineStore.default.get();

      if ((0, _LoadingStatus.isLoading)(requestedPropertiesByStage, allStageProperties, stages, pipelines)) {
        return undefined;
      }

      var stageId = nextProperties.get('dealstage');
      var customRequestedProperties = requestedPropertiesByStage.get(stageId);

      if (customRequestedProperties) {
        return customRequestedProperties.filter(function (property) {
          var propertyName = property.get('property');
          return allStageProperties.has(propertyName) && !BLACKLISTED_PROPERTIES[_ObjectTypes.DEAL].includes(propertyName);
        });
      }

      return (0, _immutable.List)();
    }
  },
  subjectProperties: {
    stores: [_PropertiesStore.default],
    deref: function deref() {
      var subjectProperties = _PropertiesStore.default.get(_ObjectTypes.DEAL);

      if ((0, _LoadingStatus.isLoading)(subjectProperties)) {
        return (0, _immutable.List)();
      }

      return subjectProperties;
    }
  },
  settings: {
    stores: [_SettingsStore.default],
    deref: (0, _bustStoreCacheIfExpired.default)()
  }
});
var fetchTicketInfo = (0, _connectPromise.connectPromise)({
  subject: {
    stores: [_TicketsStore.default],
    deref: function deref(_ref4) {
      var id = _ref4.id;
      return _TicketsStore.default.get(id);
    }
  },
  stages: {
    stores: [_TicketsPipelinesStagesStore.default],
    deref: function deref(_ref5) {
      var prevProperties = _ref5.prevProperties,
          nextProperties = _ref5.nextProperties;

      var stages = _TicketsPipelinesStagesStore.default.get();

      if ((0, _LoadingStatus.isLoading)(stages)) {
        return (0, _immutable.Map)();
      }

      return {
        prev: (0, _get.default)((0, _get.default)('hs_pipeline_stage', prevProperties), stages),
        next: (0, _get.default)((0, _get.default)('hs_pipeline_stage', nextProperties), stages)
      };
    }
  },
  stageProperties: {
    stores: [_PropertiesStore.default, _TicketsPipelinesStore.default, _TicketsPipelinesStagesStore.default, _TicketStagePropertiesStore.default],
    deref: function deref(_ref6) {
      var nextProperties = _ref6.nextProperties;

      var requestedPropertiesByStage = _TicketStagePropertiesStore.default.get();

      var allStageProperties = _PropertiesStore.default.get(_ObjectTypes.TICKET);

      var stages = _TicketsPipelinesStagesStore.default.get();

      var pipelines = _TicketsPipelinesStore.default.get();

      if ((0, _LoadingStatus.isLoading)(requestedPropertiesByStage, allStageProperties, stages, pipelines)) {
        return undefined;
      }

      var stageId = nextProperties.get('hs_pipeline_stage');
      var customRequestedProperties = requestedPropertiesByStage.get(stageId);

      if (customRequestedProperties) {
        return customRequestedProperties.filter(function (property) {
          var propertyName = property.get('property');
          return allStageProperties.has(propertyName) && !BLACKLISTED_PROPERTIES[_ObjectTypes.TICKET].includes(propertyName);
        });
      }

      return (0, _immutable.List)();
    }
  },
  subjectProperties: {
    stores: [_PropertiesStore.default],
    deref: function deref() {
      var subjectProperties = _PropertiesStore.default.get(_ObjectTypes.TICKET);

      if ((0, _LoadingStatus.isLoading)(subjectProperties)) {
        return (0, _immutable.List)();
      }

      return subjectProperties;
    }
  },
  settings: {
    stores: [_SettingsStore.default],
    deref: (0, _bustStoreCacheIfExpired.default)()
  }
});

var maybeShowModal = function maybeShowModal(objectType, _ref7) {
  var id = _ref7.id,
      pipeline = _ref7.pipeline,
      prevProperties = _ref7.prevProperties,
      nextProperties = _ref7.nextProperties;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var fetchInfo = objectType === _ObjectTypes.TICKET ? fetchTicketInfo : fetchDealInfo;
  var actions = objectType === _ObjectTypes.TICKET ? TicketsActions : DealsActions;
  (0, _UserScopes.userScopes)().then(function (scopes) {
    if (objectType === _ObjectTypes.DEAL && !(0, _DealPermissions.canMoveStage)(pipeline, prevProperties.get('dealstage'), nextProperties.get('dealstage'), scopes)) {
      return false;
    }

    return fetchInfo({
      id: id,
      prevProperties: prevProperties,
      nextProperties: nextProperties
    }).then(function (_ref8) {
      var subject = _ref8.subject,
          stages = _ref8.stages,
          stageProperties = _ref8.stageProperties,
          subjectProperties = _ref8.subjectProperties,
          settings = _ref8.settings;

      if (!stageProperties.isEmpty()) {
        return (0, _PipelineStageChangePrompt.default)({
          getPropertyInputResolver: _PropertyInputResolvers.getPropertyInputResolver,
          objectType: objectType,
          subject: subject,
          prevStage: stages.prev,
          nextStage: stages.next,
          prevProperties: prevProperties,
          PropertyInput: _PropertyInput.default,
          nextProperties: nextProperties,
          stageProperties: stageProperties,
          subjectProperties: subjectProperties,
          settings: settings,
          saveCallback: getModalSavedCallback(objectType, subject, nextProperties, stages.next, options),
          cancelCallback: getModalCanceledCallback(subject, id, prevProperties, actions.revertMove)
        });
      } // Otherwise no modal is shown so just update


      if (objectType === _ObjectTypes.DEAL) {
        var userIsChangingCloseDate = nextProperties.has('closedate');
        var probability = stages.next.get('probability') && +stages.next.get('probability');
        var dealIsWonOrLost = [0, 1].includes(probability);
        var previousStageProbability = (0, _get.default)('probability', stages.prev) && +(0, _get.default)('probability', stages.prev);

        if (!userIsChangingCloseDate && dealIsWonOrLost && previousStageProbability !== probability) {
          nextProperties = nextProperties.set('closedate', _I18n.default.moment.userTz().valueOf());
        }
      }

      return _ObjectsActions.default.updateStores(subject, nextProperties, {
        updatedValues: true,
        onError: function onError(err) {
          (0, _PropertyUpdateErrorHandler.default)(err);
          actions.revertMove(id);
        },
        onSuccess: options.onSuccess
      });
    });
  }).catch(rethrowError).done();
};

var handlers = {};

handlers[_ActionTypes.DEAL_STAGE_CHANGE] = function (_, _ref9) {
  var id = _ref9.id,
      pipeline = _ref9.pipeline,
      nextProperties = _ref9.nextProperties,
      prevProperties = _ref9.prevProperties,
      options = _ref9.options;
  maybeShowModal(_ObjectTypes.DEAL, {
    id: id,
    pipeline: pipeline,
    prevProperties: prevProperties,
    nextProperties: nextProperties
  }, options);
};

handlers[_ActionTypes.TICKET_STAGE_CHANGE] = function (_, _ref10) {
  var id = _ref10.id,
      nextProperties = _ref10.nextProperties,
      properties = _ref10.properties,
      options = _ref10.options;
  maybeShowModal(_ObjectTypes.TICKET, {
    id: id,
    prevProperties: properties,
    nextProperties: nextProperties
  }, options);
};

var _default = (0, _registerService.default)(undefined, handlers, _dispatcher.default);

exports.default = _default;
module.exports = exports.default;